import React from 'react'
import { useParams } from 'react-router'
import { Box } from '@chakra-ui/core'
import { QuantityBox } from '@engyalo/storefront-components'
import { LinkButton } from '../../lib/types'
import { useRecoilState } from 'recoil'
import { ICartDictionary } from '@engyalo/storefront-types/lib/plugins/model'
import { cartState } from '../../recoil/atoms'

export const CartIcon: React.FC = () => {
    const { customer, order } = useParams()
    const [cart] = useRecoilState<ICartDictionary>(cartState)

    const totalQty = Object.values(cart).reduce((prev, cartItem) => prev + (cartItem?.quantity ?? 0), 0)

    return (
        <Box pos="relative">
            <LinkButton
                to={`/${customer}/${order}/cart`}
                h="100%"
                w="32px"
                background="transparent"
                borderColor="unset"
                style={{
                    color: '#000',
                }}
                size="lg"
                aria-label="cart"
                icon="settings"
            />
            <Box pos="absolute" right="0" top="0">
                {totalQty > 0 ? <QuantityBox value={totalQty} size="small" /> : null}
            </Box>
        </Box>
    )
}
